import { useForm } from "react-hook-form";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ILogin, IPermissionProps } from "../../models/Login";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { IModal } from "./ShowTimesheet";
import { format } from "date-fns";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { ITimesheet, VerifyStatus } from "../../models/Timesheet";
import { VerifyForm } from "./VerifyForm";
import { Mail } from "./Mail";
import { JVInput } from "../../shared/JVInput";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { AutoFillTimeSheet } from "./AutoFillTimeSheet";
import { safeFormatDate } from "../../models/DateFormatMapper";
// import { ConnectedOverlayScrollHandler } from "primereact/utils";

interface ITimesheetFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    status?: string | null,
    consultant_Name?: string | null,
}

interface IProps {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
    byConsultant: number,
    po: IPurchaseOrder,
}

const schema = yup.object({
    date: yup.date().nullable(),
    status: yup.string().nullable(),
});

const EmptyTSFilter: ITimesheetFilter = {
    fromDate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    toDate: new Date,
    status: "",
    consultant_Name: ""
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITimesheet>, loading: boolean });
    const [autoFillTimesheet, setAutoFillTimesheet] = useState({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 } as { singleData: any, open: boolean, po: any, recent: any, timeSheetCount: number });
    const [filters, setFilters] = useState<ITimesheetFilter>(EmptyTSFilter);
    const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
    const dt = useRef<any>(null);
    const previousValue = useRef<boolean>(false);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, reset } = useForm<ITimesheetFilter>({
        resolver: yupResolver(schema),
        defaultValues: EmptyTSFilter,
        shouldFocusError: false
    });

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async (filters: ITimesheetFilter) => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let po_id_Query = "";
        if (props?.po?.pO_ID && props.po.pO_ID !== 0) {
            po_id_Query = `&byPO_ID=${props.po.pO_ID}`;
            filters.fromDate = null;
            filters.toDate = null;
        };

        const response = await Fetch("Timesheet/getTimesheetListByPO", "GET", null, `filter=${JSON.stringify(filters)}&byConsultant=${props.byConsultant}` + po_id_Query, props.toast);
        if (response) {
            const data: Array<ITimesheet> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    const loadInnerTableData = async (filters: ITimesheetFilter, consultant_ID: number, pO_ID: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Timesheet/consultant", "GET", null, `consultant_ID=${consultant_ID}&filter=${JSON.stringify(filters)}&po_ID=${pO_ID}`, props.toast);
        if (response) {
            const data: Array<ITimesheet> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    const [consultantTable, setConsultantTable] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });

    useEffect(() => {
        if (previousValue.current === consultantTable.open) {
            if (consultantTable.open && consultantTable.singleData.consultant_ID) {
                if (props.po?.pO_ID) loadInnerTableData(filters, 0, props?.po?.pO_ID)
                else loadInnerTableData(filters, consultantTable.singleData.consultant_ID, 0);
            }
            else loadTableData(filters);
        } else {
            previousValue.current = consultantTable.open;
            if (consultantTable.open && consultantTable.singleData.consultant_ID) {
                if (props?.po?.pO_ID) loadInnerTableData({}, 0, props?.po?.pO_ID)
                else loadInnerTableData({}, consultantTable.singleData.consultant_ID, 0);
                reset({});
            }
            else { loadTableData(EmptyTSFilter); reset(EmptyTSFilter); }
        }
    }, [filters, props.reload, consultantTable.open]);

    const openNew = (rowData: ITimesheet) => {
        props.setModal({ open: true, singleData: { consultant_ID: rowData.consultant_ID, pO_ID: rowData.pO_ID }, po: props.po, recent: tableData.tableData[0] });
    };
    const openEdit = (rowData: ITimesheet) => {
        props.setModal({ open: true, singleData: rowData, po: props?.po || {}, recent: {} });
    };

    const [verify, setVerify] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });
    const hideVerifyDialog = () => { setVerify({ singleData: {}, open: false }); loadTableData(filters); };
    const [mail, setMail] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });
    const hideMailDialog = () => { setMail({ singleData: {}, open: false }) };
    const hideAutoFilltTimesheetDialog = () => { setAutoFillTimesheet({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 }); };

    const downloadTimeSheet = async (data: ITimesheet) => {
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"Timesheet/download"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.timeSheet_Path ? data.timeSheet_Path : "timeSheet";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const leftToolbarTemplate = () => {
        if (props?.po?.pO_ID) {
            return (
                <React.Fragment>
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 w-6rem" onClick={() => {
                        // if ((new Date() <= new Date(props.po.project_End_Date || "")) && props.po.pO_Status === "Joined" && !props.po.prime_Vendor_Billing_Cycle) {
                        //     props.toast.current.show({ severity: 'error', detail: "Please Enter Prime Vendor Billing Cycle First", life: 3000 });
                        // } else 

                        // if ((new Date() <= new Date(props.po.project_End_Date || "")) && props.po.pO_Status === "Joined" && props.po.prime_Vendor_Billing_Cycle) {
                        props.setModal({ open: true, singleData: { consultant_ID: props?.po?.consultant_ID, pO_ID: props?.po?.pO_ID }, po: props?.po, recent: tableData.tableData[0] });
                        // } else if ((new Date() > new Date(props.po.project_End_Date || ""))) {
                        //     props.toast.current.show({ severity: 'error', detail: "Project Ended", life: 3000 });
                        // } else if (props.po.pO_Status !== "Joined") {
                        //     props.toast.current.show({ severity: 'error', detail: `Consultant PO Status ${props.po.pO_Status}`, life: 3000 });
                        // };
                    }} />
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    {consultantTable.open && <Button label="Go Back" icon="pi pi-arrow-left" className="p-button-info" onClick={() => setConsultantTable({ singleData: {}, open: false })} />}
                </React.Fragment>
            );
        }
    };
    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <div className="flex w-full">
                        {(_roles.includes(20) || _roles.includes(1) || (_roles.includes(30) || _roles.includes(31))) && <div className="flex w-25rem">{timesheetLeft !== 0 && <h1 className="flex text-4xl font-bold mr-5 hover:text-blue-700 hover:underline" style={{ cursor: "pointer" }} onClick={() => {
                            setAutoFillTimesheet({ open: true, singleData: { consultant_ID: props.po.consultant_ID, pO_ID: props.po.pO_ID }, po: props.po, recent: tableData.tableData[0], timeSheetCount: timesheetLeft });
                        }}>Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>}
                    </div>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ((_roles.includes(20) || _roles.includes(1) || (_roles.includes(30) || _roles.includes(31))) && <div className="flex align-items-center justify-content-center">
                    <div>{timesheetLeft !== 0 && <h1 className="text-4xl font-bold mr-5" style={{ cursor: "pointer" }} onClick={() => {
                        setAutoFillTimesheet({ open: true, singleData: { consultant_ID: props.po.consultant_ID, pO_ID: props.po.pO_ID }, po: props.po, recent: tableData.tableData[0], timeSheetCount: timesheetLeft });
                    }}>Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>
                </div>)
        );
    };

    const onSubmit = (data: ITimesheetFilter) => {
        if (data.status === "--SELECT--") data.status = "";
        setFilters(data);
    }

    const newTS = (rowData: ITimesheet) => {
        return (<Button icon="pi pi-plus" className="p-button-success p-button-rounded p-button-text" onClick={() => openNew(rowData)} />);
    };
    const consultant_Name = (rowData: ITimesheet) => {
        const currentDate = new Date();
        return (
            <>{!consultantTable.open ? <span onClick={() => setConsultantTable({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.consultant_Name}
            </span > : rowData.consultant_Name
            }</>
        );
    }
    const start_Date = (rowData: ITimesheet) => {
        let date;
        if (rowData.start_Date) date = format(new Date(rowData.start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const fromDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const actionBodyTemplate = (rowData: ITimesheet) => {
        if (!(_roles.includes(1) || _roles.includes(49)) && rowData.verifiedBy !== null && rowData.verify_Status === VerifyStatus.Verified) {
            return "";
        }
        return (
            props.permissions.is_Update ?
                <>
                    <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text w-5rem" onClick={() => {
                        if (rowData.timesheet_ID) openEdit({
                            timesheet_ID: rowData.timesheet_ID,
                            consultant_ID: rowData.consultant_ID,
                            fromDate: new Date(rowData.fromDate || ""),
                            toDate: new Date(rowData.toDate || ""),
                            workHours: rowData.workHours,
                            comments: rowData.comments,
                            isNotWorking: rowData.isNotWorking,
                            timeSheet_Path: rowData.isNotWorking === true ? "null" : rowData.timeSheet_Path,
                            overlapWorkHours: rowData.overlapWorkHours,
                        })
                    }} />
                    {!(_roles.includes(30) || _roles.includes(31)) && <Button icon="pi pi-check" label="Verify" className="p-button-rounded p-button-info p-button-text w-6rem" onClick={() => {
                        if (rowData.timesheet_ID) setVerify({
                            singleData: {
                                timesheet_ID: rowData.timesheet_ID,
                                consultant_ID: rowData.consultant_ID,
                                verify_Status: rowData.verify_Status,
                                verify_Comment: rowData.verify_Comment
                            }, open: true
                        })
                    }} />}
                </>
                : ''
        );
    };
    const d_timesheet = (rowData: ITimesheet) => {
        return (<span onClick={() => {
            if (rowData.consultant_ID && rowData.timeSheet_Path && rowData.isNotWorking !== true) downloadTimeSheet({ pO_ID: rowData.pO_ID, timeSheet_Path: rowData.timeSheet_Path })
            else if (rowData.isNotWorking === true) props.toast.current.show({ severity: 'error', detail: "Consulant Not Worked This Week.", life: 3000 })
            else props.toast.current.show({ severity: 'error', detail: "TimeSheet Not Found.", life: 3000 });
        }} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };
    const send_Email = (rowData: ITimesheet) => {
        return (<span onClick={() => setMail({ singleData: rowData, open: true })} className="cursor-pointer text-cyan-700 underline">Send Email</span>);
    };

    const rowClass = (data: ITimesheet) => {
        return {
            'bg-green-300 text-black': data.verify_Status === VerifyStatus.Verified || data.verify_Status === VerifyStatus.Not_Worked,
            'bg-yellow-100 text-black': data.verify_Status === null || data.verify_Status === VerifyStatus.Pending,
            'bg-pink-100 text-black': data.verify_Status === VerifyStatus.UnVerified,
        };
    };

    const status = (rowData: ITimesheet) => {
        return <span style={{ color: (rowData.verify_Status === VerifyStatus.UnVerified) ? "red" : "black" }}>{rowData.isNotWorking === true ? "Did not Worked" : rowData.verify_Status ? VerifyStatus[rowData.verify_Status] : ''}</span>;
    };

    const GetTimesheetLeft = async () => {
        const response = await Fetch("vwPODetails/getTimesheetOrInvoiceLeft", "GET", null, `PO_ID=${props?.po?.pO_ID}&dataType=1`, props.toast);
        if (response) {
            const data = await response.json();
            setTimesheetLeft(data.timesheetLeft);
        }
    };
    useEffect(() => {
        if (props?.po?.pO_ID) {
            GetTimesheetLeft();
        }
    }, []);

    const DateFromat = loginObj.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {!props?.po?.pO_ID && <Accordion>
                <AccordionTab header="Filter">
                    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                        <JVDate column={6} label="From Date" control={control} name="fromDate" />
                        <JVDate column={6} label="To Date" control={control} name="toDate" />
                        <JVDropdown column={6} label="Status:" control={control} name="status" options={[
                            { name: "--SELECT--" },
                            { name: "Pending" },
                            { name: "Complete" },
                        ]} optionLabel="name" optionValue="name" placeholder="Select Status" />
                        <JVInput column={6} label="Consultant Name" control={control} name="consultant_Name" />
                        <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                            <Button className="field col-12 md:col-6  h-2rem" label="SEARCH" type="submit"></Button>
                            <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => { reset() }} type="button"></Button>
                        </div>
                    </form>
                </AccordionTab>
            </Accordion>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
                rowClassName={rowClass}
                scrollable
                scrollHeight="100vh"
            >
                {!props?.po?.pO_ID && <Column body={newTS} style={{ minWidth: '100px' }} />}
                <Column field="consultant_Name" header="Name" style={{ minWidth: '180px' }} />
                <Column field="sales" header="Sales Manager" style={{ minWidth: '100px' }} />
                <Column field="recruiter" header="Recruiter" style={{ minWidth: '100px' }} />
                <Column field="client" header="Client" style={{ minWidth: '180px' }} />
                <Column field="end_Client" header="End Client" style={{ minWidth: '100px' }} />
                <Column field="vendor" header="Vendor" style={{ minWidth: '130px' }} />
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="start_Date" header="Start Date" body={start_Date} /> */}
                <Column field="fromDate" header="From Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFromat)} />
                <Column field="toDate" header="To Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFromat)} />
                <Column field="start_Date" header="Start Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.start_Date, 'dd/MM/yyyy', DateFromat)} />
                <Column field="workHours" header="Hours" body={(rowData: any) => <p>{(rowData.workHours || 0) + (rowData.overlapWorkHours || 0)}</p>} style={{ minWidth: '100px' }} />
                <Column header="Show" body={d_timesheet} style={{ minWidth: '100px' }} />
                <Column field="addedBy" header="Added By" style={{ minWidth: '100px' }} />
                <Column field="editedBy" header="Edited By" style={{ minWidth: '130px' }} />
                <Column field="verifiedBy" header="Verified By" style={{ minWidth: '100px' }} />
                <Column field="timeSheet_Status1" header="Status" body={status} />
                <Column header="Email Inv" body={send_Email} style={{ minWidth: '100px' }} />
                <Column header="Action" body={actionBodyTemplate} style={{ minWidth: '180px' }} />
            </DataTable>
            <VerifyForm singleData={verify.singleData} open={verify.open} toast={props.toast} hideDialog={hideVerifyDialog} reload={props.reload} setReload={props.setReload} />
            <Mail singleData={mail.singleData} open={mail.open} toast={props.toast} hideDialog={hideMailDialog} />
            <AutoFillTimeSheet singleData={autoFillTimesheet.singleData} open={autoFillTimesheet.open} hideDialog={hideAutoFilltTimesheetDialog} toast={props.toast} setReload={props.setReload} po={props?.po} recent={autoFillTimesheet.recent} timeSheetCount={autoFillTimesheet.timeSheetCount} reloadDialog={() => {
                loadTableData(filters);
                GetTimesheetLeft();
            }} />
        </>
    );
}